import { Navigate } from "react-router-dom";

const LoginProtectedRoute = ({ user, children }) => {
  if (user) {
    return <Navigate to="/posts" replace />;
  }

  return children;
};
export default LoginProtectedRoute;
